<div cdkTrapFocus aria-live="assertive">
  <div class="modal-header">
    <h3 class="modal-title" id="modal-header">
      TravelFusion <span i18n="@@modalWarningTitle">Warning</span>
    </h3>
    <button
      type="button"
      class="close"
      aria-label="An Error Occured Close"
      ngbAutoFocus
      i18n-aria-label
      (click)="activeModal.close('Cross click')"
    >
      <span aria-hidden="true"><i class="ico-cancel modal_exit_cross"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <p>
      The price if this item has changed due to charges related to your payment method. Please
      review the price change before proceeding with your booking. If you want to change your
      payment method, please select stop booking and update your payment method.
    </p>
    <p>Old Price: {{ price | currency: currency : 'symbol' : '1.2-2' }}</p>
    <p>New Price: {{ newPrice | currency: currency : 'symbol' : '1.2-2' }}</p>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="modal_button_okay"
      (click)="activeModal.close(true)"
      i18n="@@AcceptAndContinue"
    >
      Accept and Continue
    </button>
    <button
      type="button"
      class="modal_button_okay"
      (click)="activeModal.close(false)"
      i18n="@@modalTravelFusionStopBooking"
    >
      Stop Booking
    </button>
  </div>
</div>
